import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOktaQuery, Playlists } from '../../../data';
import usePlayerSelector from '../../../utils/usePlayerSelector';
import PlaylistReport from '../../../components/PlaylistReport';

const OpposingPlayerPlaylists = ({ playerId: opposingPlayerId }) => {
    const { t: translate } = useTranslation();
    const { PlayerID } = usePlayerSelector();
    const { data: playlists, isLoading } = useOktaQuery(['playlist-opposing-player', PlayerID, opposingPlayerId],
        (t) => Playlists.getOppsoingPlayerPlaylist(t, PlayerID, opposingPlayerId));

    return <PlaylistReport title={translate('sections.opponent.player.player-playlists')} isLoading={isLoading} playlists={playlists} />;
};

export default OpposingPlayerPlaylists;
